import type { ToastStoreState } from './toast.type'

export const toastInitialState: ToastStoreState = {
  toasts: [],
}
